import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  LongMessage,
  PublicLongEchoOptions,
  publicLongEcho as universalPublicLongEcho,
} from './metroinspector-v1-long-echo.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/core-services-d' };

export function publicLongEcho(
  httpClient: HttpClient
): PublicLongEchoSignature {
  return (options?: PublicLongEchoOptions) =>
    universalPublicLongEcho(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface PublicLongEchoSignature {
  /**
   * echo given arg1 and arg2
   */
  (options?: PublicLongEchoOptions): Promise<
    NonNullablePaths<
      LongMessage,
      | `int64Field`
      | `uint64Field`
      | `sint64Field`
      | `sfixed64Field`
      | `fixed64Field`,
      2
    >
  >;
}

export {
  LongMessage,
  PublicLongEchoOptions,
} from './metroinspector-v1-long-echo.universal.js';
